import React from "react";

import Box from "@mui/material/Box";
import { CssBaseline } from "@mui/material";

import UsersView from "../modules/Users";

export default function Users() {
  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <UsersView />
    </Box>
  );
}
